import React from "react";
import { Switch } from "react-router-dom";
import { AuthedRoutes } from "../components/AuthedRoutes";
import VakTest from "../pages/vak/vak-test";

export const vakRoutes = () => {
  return (
    <Switch>
      <AuthedRoutes
        menu="competency"
        exact
        path={"/vak"}
        component={VakTest}
        showBreadcrumb={false}
        headerTitle="Sensory Learning Preference"
        noPadding
      ></AuthedRoutes>
    </Switch>
  );
};
